module.exports = __webpack_public_path__ + "img/snow_fall_00007.9e764eb4.png";